// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"deleteButton--2l6XK"};